import classNames from "classnames";
import React, { useEffect, useState } from "react";

interface Props {
  children: React.ReactNode;
  className?: string;
  maxLength?: number;
  disabled?: boolean;
  onChange: (value: string) => void;
}

export const Body14TextInput: React.FC<Props> = ({
  children,
  maxLength,
  disabled,
  className,
  onChange,
}) => {
  const [value, setValue] = useState(children?.toString() || "");

  useEffect(() => {
    setValue(children?.toString() || "");
  }, [children]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;

    if (maxLength && newValue.length > maxLength) {
      const truncatedValue = newValue.slice(0, maxLength);
      setValue(truncatedValue);
      onChange(truncatedValue);
      return;
    }

    setValue(newValue);
    onChange(newValue);
  };

  const classNamesString = classNames(
    "text-body-14 font-regular leading-body-14  bg-transparent outline-none border-none pl-0 w-[300px]",
    className
  );

  return (
    <input
      type="text"
      value={value}
      className={classNamesString}
      disabled={disabled}
      onChange={handleChange}
      maxLength={maxLength}
    />
  );
};
